<template>
  <ConsultForm />
</template>

<script>
import ConsultForm from "../components/ConsultForm.vue";
export default {
  name: "SingleForm",
  components: { ConsultForm },
};
</script>
